// Module
var code = `<action-card headline="yourGrowers.HEADLINE"> <ul class="divide-y divide-gray-200"> <li class="py-2" ng-repeat="grower in \$ctrl.growers| orderBy: 'name'"> <a class="text-harvustorange" ui-sref="app.growers.grower.manage({grower_sid: grower.sid})"> {{ grower.name | ucfirst }} </a> </li> </ul> </action-card> `;
// Exports
export default code;